import React, { createContext, useState, useEffect, useContext } from 'react';
import { getCourses, createCourse, updateCourse, deleteCourse } from '@services/courseService';
import { useAnalytics } from './AnalyticsContext';

export const CourseContext = createContext();

export const CourseProvider = ({ children }) => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { incrementData, decrementData } = useAnalytics();

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const data = await getCourses();
        setCourses(data);
      } catch (error) {
        console.error('Error fetching courses:', error);
        setError('Failed to fetch courses data.');
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  const addCourse = async (courseData) => {
    try {
      const newCourse = await createCourse(courseData);
      setCourses([...courses, newCourse]);
      incrementData('total_courses');
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

  const editCourse = async (courseId, courseData) => {
    try {
      const updatedCourse = await updateCourse(courseId, courseData);
      setCourses(courses.map(course => (course.id === courseId ? updatedCourse : course)));
    } catch (error) {
      console.error('Error updating course:', error);
      throw error;
    }
  };

  const removeCourse = async (courseId) => {
    try {
      await deleteCourse(courseId);
      setCourses(courses.filter(course => course.id !== courseId));
      decrementData('total_courses');
    } catch (error) {
      console.error('Error deleting course:', error);
      throw error;
    }
  };

  return (
    <CourseContext.Provider value={{ courses, loading, error, addCourse, editCourse, removeCourse }}>
      {error ? (
        <div className="flex items-center justify-center h-screen">
          <p className="text-red-500">{error}</p>
        </div>
      ) : (
        children
      )}
    </CourseContext.Provider>
  );
};

export const useCourses = () => useContext(CourseContext);